// extracted by mini-css-extract-plugin
export default {"colon":"pilgrim_colon__SMntK","pilgrimCountBlock":"pilgrim_pilgrimCountBlock__R+LLD"};